import { render } from "./PopoverItem.vue?vue&type=template&id=51a90372&scoped=true"
import script from "./PopoverItem.vue?vue&type=script&lang=js"
export * from "./PopoverItem.vue?vue&type=script&lang=js"

import "./PopoverItem.vue?vue&type=style&index=0&id=51a90372&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a90372"]])

export default __exports__